export class DeputyDto {
    keyId: string = '';
    id: string = '';
    executorUserId: string = '';
    executorName: string = '';
    executorEmail: string = '';
    executorMobile: string = '';
    agentUserId: string = '';
    agentName: string = '';
    agentEmail: string = '';
    agentMobile: string = '';
    startTime: string = '';
    endTime: string = '';
}